import axios from "axios";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  async new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    await Promise.all(
      data.map(async (element) => {
        payload = {
          empId: element.empId,
          operId: parseInt(localStorage.getItem("operId"), 10),
          fecha:
            element.date.slice(0, 10).split(/\D/).reverse().join("-") +
            "T00:00:00.000Z",
        };
        await axios.post(`${url}/firmarNovedad`, payload, { headers });
      })
    );
  }
  async notFirmNovelty(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload;

    await Promise.all(
      data.map(async (element) => {
        payload = {
          empId: element.empId,
          operId: parseInt(localStorage.getItem("operId"), 10),
          fecha:
            element.date.slice(0, 10).split(/\D/).reverse().join("-") +
            "T00:00:00.000Z",
        };
        await axios.post(`${url}/retirarFirmarNovedad`, payload, { headers });
      })
    );
  }
}
export default service;
